import React from 'react';
import styled from 'styled-components';
import { FaPlus, FaMinus } from "react-icons/fa6";
import { theme } from '../../theme/GlobalTheme';

const AdvancedButton = styled.button`
  border: 1px solid ${theme.colors.primary};
  background-color: ${theme.colors.white};
  color: ${theme.colors.primary};
  padding: ${theme.spacing.md};
  font-size: ${theme.typography.fontSize.body};
  font-family: ${theme.typography.fontFamily};
  font-weight: ${theme.typography.fontWeight.bold};
  border-radius: ${theme.borderRadius.medium};
  cursor: pointer;
  transition: all 0.2s ease-in-out;
  margin: 0 0 ${theme.spacing.md} 0;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: ${theme.spacing.sm};
  
  &:hover {
    background-color: ${theme.colors.primary};
    color: ${theme.colors.white};
    transform: translateY(-1px);
    box-shadow: ${theme.shadows.light};
  }
  
  &:active {
    transform: translateY(0);
  }
`;

const AdvancedSettingsButton = ({ showAdvanced, onToggle }) => {
  return (
    <AdvancedButton type="button" onClick={onToggle}>
      {showAdvanced ? (
        <>
          <FaMinus /> Hide Advanced Variables
        </>
      ) : (
        <>
          <FaPlus /> Show Advanced Variables
        </>
      )}
    </AdvancedButton>
  );
};

export default AdvancedSettingsButton;
